export enum SaveState {
    NotSaving,
    Saving,
    Saved,
}
